import React from "react";
import logo from "../../../assets/img/logos/logo.svg";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import NavBarButtonSetup from "./NavBarButtonSetup";

import { makeStyles } from 'tss-react/mui';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  root: {},
  title: {
    flexGrow: 1,
  },
  logo: {
    maxWidth: "80%",
    maxHeight: 35,
    paddingTop: 5,
    paddingBottom: 5,
  },
  navbar: {
    backgroundColor: "white",
    boxShadow: "none !important",
  },
  noHeightLink: {
    display: "block",
    lineHeight: 0,
    fontSize: 0,
  },
  toolbar: {
    padding: "0px 30px",
  },
}));

function NavBar(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={`${classes.navbar} navBar`}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.title}>
            <Link to="/" className={classes.noHeightLink}>
              <img src={logo} alt="logo" className={classes.logo} />{" "}
            </Link>
          </div>
          <NavBarButtonSetup />
        </Toolbar>
      </AppBar>
    </div>
  );
}

NavBar.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  authenticated: state.user.authenticated,
  imageUrl: state.user.credentials.imageUrl,
});

export default connect(mapStateToProps)(NavBar);
